const getYearDiagnosedOptions = (): React.ReactElement[] => {
  const currentYear = parseInt(new Date().getFullYear().toString(), 10);
  let i = currentYear;
  const years = [];
  for (i; i >= currentYear - 100; i -= 1) {
    years.push(
      <option key={i} value={i}>
        {i}
      </option>,
    );
  }
  return years;
};

export default getYearDiagnosedOptions;
